import 'base-styles/reset.sss';

import { h, render } from 'preact';
// import { buildClientStoreData } from 'utils/bolt';
import BoltBannerApp from 'base/boltBanner/boltBannerApp';

try {
	let url = location.origin + location.pathname.replace(/\/[^/]*$/, '/');
	// eslint-disable-next-line no-undef
	__webpack_public_path__ = url + (window.__RELATIVE_ROOT__ || '') + 'js/';
} catch (e) {}

/* Initial render of the app
----------------------------------*/

let elem = document.getElementById('app') || document.body;
render(<BoltBannerApp initialStore={window.__INITIAL_STATE__} />, elem, elem.firstChild);
